import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import DashboardLayout from "../components/layout/DashboardLayout";
import Dashboard from "../pages/dashboard/page";
import Companies from "../pages/companies/page";
import CompanyDetail from "../pages/company-detail/page";
import Users from "../pages/users/page";
import Customers from "../pages/customers/page";
import CustomerDetail from "../pages/customer-detail/page";
import KycRequests from "../pages/kyc-requests/page";
import Documents from "../pages/documents/page";
import AuditLogs from "../pages/audit-logs/page";
import Reports from "../pages/reports/page";
import Settings from "../pages/settings/page";
import KycDetail from "../pages/kyc-detail/page";
import Masters from "../pages/masters/page";
import ProtectedRoute from "../components/protected/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/companies",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute roles={["superadmin"]}>
            <Companies />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/companies/:id",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute roles={["superadmin"]}>
            <CompanyDetail />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/users",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["users.manage"]}>
            <Users />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/customers",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["customers.manage", "customers.view"]}>
            <Customers />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/customers/:id",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["customers.manage", "customers.view"]}>
            <CustomerDetail />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/kyc-requests",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["kyc.manage", "kyc.review", "kyc.self"]}>
            <KycRequests />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/kyc/:id",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["kyc.manage", "kyc.review", "kyc.self"]}>
            <KycDetail />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/documents",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["documents.manage", "documents.view", "documents.self"]}>
            <Documents />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/audit-logs",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["audit.view"]}>
            <AuditLogs />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/reports",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["reports.view"]}>
            <Reports />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/settings",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute permissions={["settings.manage"]}>
            <Settings />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/masters",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute roles={["superadmin"]}>
            <Masters />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
